import { atom } from 'jotai';
import { FlashbarProps } from '@cloudscape-design/components';

/**
 * Atom storing Cloudscape Flashbar messages for global notification management
 * Uses FlashbarProps.MessageDefinition[] type from @cloudscape-design/components
 * Empty array as initial state
 */
export const flashbarAtom = atom<FlashbarProps.MessageDefinition[]>([]);
